import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const I18nContext = createContext({
  language: 'en',
  translations: {},
  t: (key, fallback) => fallback || key,
  setLanguage: () => {},
  languages: [],
});

export function I18nProvider({ children }) {
  const [language, setLanguageState] = useState(() => localStorage.getItem('app_language') || 'en');
  const [translations, setTranslations] = useState({});
  const [languages, setLanguages] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    axios.get(`${API}/i18n/languages`).then(r => {
      setLanguages(r.data.languages || []);
    }).catch(() => {});
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    axios.get(`${API}/i18n/translations/${language}`).then(r => {
      setTranslations(r.data.translations || {});
    }).catch(() => {});
  }, [language]);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    localStorage.setItem('app_language', lang);
  }, []);

  const t = useCallback((key, fallback) => {
    if (translations[key]) {
      return translations[key];
    }
    return fallback || key.split('.').pop();
  }, [translations]);

  return (
    <I18nContext.Provider value={{ language, translations, t, setLanguage, languages }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
